import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";

function Grievance() {
  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const user_captcha = e.target.captcha.value;

    if (validateCaptcha(user_captcha) === true) {
      e.target.action = "https://formsubmit.co/vbumca@gmail.com";
      e.target.method = "POST";
      e.target.submit();
    } else {
      alert("Captcha does not match. Please try again.");
      loadCaptchaEnginge(6);
      e.target.captcha.value = "";
    }
  };

  return (
    <>
      <Helmet>
        <title>Grievance Registration - VBU MCA</title>
      </Helmet>
      <div className="PageContainer">
        <div id="Heading">
          <h1>Grievance Registration Form</h1>
        </div>
        <div className="GrievanceContainer" data-aos="fade-up">
          <div className="GrievanceNotice">
            <p><strong>Note:</strong> In accordance with the AICTE (Redressal of Grievance of Students) Regulations, 2019, students can register their grievances here. All information will be treated with absolute confidentiality.</p>
          </div>
          
          <form className="StandardForm GrievanceForm" onSubmit={handleSubmit} encType="multipart/form-data" method="POST">
            <input type="hidden" name="_subject" value="New Grievance Registered - VBU MCA" />
            <div className="FormRow">
              <div className="InputField">
                <label>Full Name</label>
                <input type="text" name="name" placeholder="Your Name" required />
              </div>
              <div className="InputField">
                <label>Category</label>
                <select name="category" required>
                  <option value="">Select Category</option>
                  <option value="Student">Student</option>
                  <option value="Faculty">Faculty</option>
                  <option value="Staff">Non-Teaching Staff</option>
                  <option value="Parent">Parent</option>
                </select>
              </div>
            </div>

            <div className="FormRow">
              <div className="InputField">
                <label>Mobile Number</label>
                <input type="tel" name="mobile" placeholder="Mobile No." required />
              </div>
              <div className="InputField">
                <label>Email ID</label>
                <input type="email" name="email" placeholder="Email Address" required />
              </div>
            </div>

            <div className="FormRow">
              <div className="InputField">
                <label>Nature of Grievance</label>
                <select name="nature" required>
                  <option value="">Select Nature of Grievance</option>
                  <option value="Academic">Academic (Result, Exam, Attendance, etc.)</option>
                  <option value="Administrative">Administrative (Fee, Scholarship, Library, etc.)</option>
                  <option value="Harassment">Harassment / Misbehavior</option>
                  <option value="Ragging">Anti-Ragging Related</option>
                  <option value="Infrastructure">Infrastructure / Facilities</option>
                  <option value="Others">Others</option>
                </select>
              </div>

              <div className="InputField">
                <label>Supporting Documents (if any)</label>
                <input type="file" name="attachment" className="FileInput" />
                <small>Acceptable formats: PDF, JPG, PNG (Max size: 5MB)</small>
              </div>
            </div>

            <div className="InputField">
              <label>Enter Captcha</label>
              <div className="CaptchaWrapper" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                <LoadCanvasTemplate />
                <input
                  type="text"
                  name="captcha"
                  placeholder="Enter Captcha Here"
                  className="capthca_box"
                  required
                  style={{ width: '200px' }}
                />
              </div>
            </div>

            <div className="FormAction">
              <button type="submit" className="SubmitBtn">Submit Grievance</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Grievance;
